<template>
  <div>
    <!-- <b-button @click="saveData(itemList)">Guardar</b-button> -->
    <LeyesPromulgadas
      v-for="(item, index) in listaLeyesPromulgadas"
      :key="index"
      :removeItem="removeItem"
      :objTest="item"
      :index="index"
      :readOnly="readOnly"
    />

    <div v-if="!readOnly" class="add-btn" @click="addItemList" v-b-tooltip.hover title="Agregar otra Ley Promulgada">
      <hr class="separator-hr" />
      <b-button class="button-leyes"><i class="bx bx-plus"></i></b-button>
      <hr class="separator-hr" />
    </div>
  </div>
</template>
<script>
import LeyesPromulgadas from "./LeyesPromulgadas.vue";
export default {
  components: {
    LeyesPromulgadas,
  },
  data() {
    return {
      anio: process.env.VUE_APP_ANIO,
      itemList: [],
    };
  },
  props: ["listaLeyesPromulgadas", "addItemList", "removeItem", "readOnly"],
  mounted() {
    this.addItemList();
  },
};
</script>
<style scoped>
.add-btn {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
}
.separator-hr {
  width: 45%;
}
.button-leyes {
  font-size: 20px;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  border: 2px solid #ccc;
  background: white;
  padding: 0;
  color: #ccc;
}
.bx-plus {
  position: relative;
  left: -2px;
  top: -5px;
}
.btn-check:focus + .btn,
.btn-secondary:hover,
.btn:focus {
  box-shadow: none;
  color: #ccc;
  border: 2px solid #ccc;
  background: white;
}
</style>
